<template>
  <div class="goods_manage_add_wrap">
    <div class="header">
      <el-button size="medium" @click="goBack">返回</el-button>
      <el-button size="medium" type="primary" @click="saveModule">保存</el-button>
      <el-button size="medium" type="primary" @click="mobilePreview">预览</el-button>
    </div>
    <div class="card_template_add_box" :style="`height: ${windowHeight - 170}px;`">
      <div class="card_template_add_content">
        <el-form :model="formData" :rules="rules" ref="form" label-width="140px" class="demo-ruleForm">
          <el-form-item label="物品名称" prop="goodsName">
            <el-input v-model="formData.goodsName" :minlength="2" :maxlength="16" placeholder="请输入卡名称"></el-input>
          </el-form-item>
          <el-form-item label="物品分类" prop="typeCode">
            <el-select v-model="formData.typeCode" placeholder="请选择分类" size="medium" @change="changeType">
              <el-option v-for="(item, index) in typeList" :key="index" :label="item.value" :value="item.code"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="物品图片" prop="goodsLogo">
            <uploader pathPrefix="cardTemplate" :extList="['bmp', 'png', 'jpg', 'jpeg']" showResult="image" v-model="goodsLogo" :openDelete="true"></uploader>
          </el-form-item>
          <el-form-item label="所需积分" prop="requirePoint">
            <el-input-number v-model="formData.requirePoint" controls-position="right" :min="1" :max="100000"></el-input-number>
          </el-form-item>
          <el-form-item label="物品详情" prop="details">
            <ueditor class="rich-editor" ref="ueditor" :defaultMes="formData.details" @editModel="richTextEditHandler"></ueditor>
          </el-form-item>
        </el-form>
      </div>
    </div>

    <el-dialog title="手机端预览" :visible.sync="isShowMobileBox" :close-on-press-escape='false' width="500px" top="5vh"
               :lock-scroll="false" :close-on-click-modal='false' :modal-append-to-body='false'>
      <div class="mobile_page_wrap">
        <div class="mobile_page_box">
          <div class="goods_box">
            <div class="goods_img_box" v-if="goodsLogo.length">
              <img :src="goodsLogo[0].fileUrl" alt="" class="goods_pic">
            </div>
            <div class="point_box">所需积分：{{formData.requirePoint}}分</div>
            <div class="goods_detail_box">
              <div v-html="formData.details"></div>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import windowResize from '@/mixins/windowResize';
  import Uploader from "@/components/Uploader/WebUploader";
  import Ueditor from "@/components/Ueditor";
  import {findDicsByCode} from '@/api/common/common';
  import {addIntegralGoods, editIntegralGoods, getIntegralGoodsInfoById} from '@/api/integralBank';

  export default {
    name: "goodsManageAdd",
    components: {Uploader, Ueditor},
    data() {
      const validateLogo = (rule, value, callback) => {
        if (!this.goodsLogo.length) {
          callback(new Error('请上传物品图片'));
        } else {
          callback();
        }
      };
      return {
        isShowMobileBox: false,
        typeList: [],
        goodsId: this.$route.query.goodsId,
        formData: {
          details: '',
          goodsLogo: '',
          goodsName: '',
          goodsStatus: 1,
          requirePoint: 100,
          typeCode: '',
          typeName: ''
        },
        rules: {
          goodsName: [
            { required: true, trigger: 'blur', message: '请输入物品名称' },
            { min: 2, max: 16, message: "输入长度在2到16个字符", trigger: "change" }
          ],
          typeCode: [
            { required: true, trigger: 'blur', message: '请选择物品分类' },
          ],
          goodsLogo: [
            {required: true, validator: validateLogo}
          ],
          requirePoint: [
            {required: true, trigger: 'blur', message: '请填写所需积分'}
          ],
          details: [
            {required: true, trigger: 'blur', message: '请填写物品详情'}
          ]
        },
        goodsLogo: [],
      }
    },
    mixins: [windowResize],
    created() {
      if (this.goodsId) this.getIntegralGoodsInfoById();
      this.findDicsByCode();
    },
    methods: {
      goBack() {
        this.$router.go(-1);
      },
      mobilePreview() {
        this.isShowMobileBox = true;
      },
      changeType() {
        this.formData.typeName = this.getCodeName();
      },
      richTextEditHandler(content) {
        this.formData.details = content;
      },
      findDicsByCode() {
        findDicsByCode({dicCode: 'integralGoodsType'}).then(res => res.data).then(data => {
          if (data.code === 200 && data.result) {
            this.typeList = data.data;
          }
        });
      },
      getIntegralGoodsInfoById() {
        getIntegralGoodsInfoById({id: this.goodsId}).then(res => res.data).then(data => {
          if (data.code === 200 && data.result) {
            this.formData = {
              details: data.data.details,
              goodsLogo: data.data.goodsLogo,
              goodsName: data.data.goodsName,
              goodsStatus: data.data.goodsStatus,
              requirePoint: data.data.requirePoint,
              typeCode: data.data.typeCode,
              typeName: data.data.typeName
            };
            this.goodsLogo = [{
              fileUrl: data.data.goodsLogo
            }];
          }
        });
      },
      saveModule() {
        this.$refs.form.validate(isValid => {
          if(isValid) {
            this.formData.goodsLogo = this.goodsLogo[0].fileUrl;
            console.log(this.formData);
            new Promise(resolve => {
              if(this.goodsId) {
                this.formData.id = this.goodsId;
                editIntegralGoods(this.formData).then(res => res.data).then(resolve)
              } else {
                addIntegralGoods(this.formData).then(res => res.data).then(resolve)
              }
            }).then(data => {
              if (data.code === 200 && data.result) {
                this.$message.success(`${this.goodsId ? '编辑' : '新增'}成功`);
                window.setTimeout(() => {
                  this.goBack();
                }, 500);
              } else {
                this.$message.success(data.msg);
              }
            })
          }
        })
      },
      getCodeName() {
        let name = '';
        this.typeList.forEach((item) => {
          if (item.code === this.formData.typeCode) {
            name = item.value;
          }
        });
        return name;
      }
    }
  }
</script>

<style>
  .goods_manage_add_wrap .upload-block-container .upload-file-item{
    width: 125px;
    height: 85px;
  }
  .goods_manage_add_wrap .upload-block-container .upload-file-item img{
    width: 120px;
  }
  .goods_manage_add_wrap .el-form-item__content{
    line-height: normal;
  }
  .goods_detail_box img{
    max-width: 100%;
  }
</style>
<style lang="scss" scoped>
  @import './../../styles/mixin';

  .goods_manage_add_wrap{
    padding: 12px;

    .header {
      padding-bottom: 10px;
      border-bottom: 1px solid #eee;
    }

    .card_template_add_box{
      @include scrollBar;

      .card_template_add_content{
        width: 810px;
        margin: 0 auto;
        padding-top: 20px;

      }
    }

    .mobile_page_wrap{
      .mobile_page_box{
        @include scrollBar;
        width: 375px;
        height: 667px;
        margin: 0 auto;
        border: 1px solid #efefef;
        .goods_box{
          min-height: 667px;
          overflow: hidden;
          background-color: #f8f8f8;
          .goods_img_box{
            background-color: #fff;
            .goods_pic{
              display: block;
              width: 100%;
            }
          }
          .point_box{
            height: 24px;
            line-height: 24px;
            margin: 8px 10px;
            padding: 0 15px;
            color: #E6A23C;
            background-color: #FDF6EC;
            border: 1px solid #F5DAB1;
            border-radius: 12px;
          }
          .goods_detail_box{
            padding: 5px 8px;
            background-color: #fff;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/integralBank/goodsManageAdd.vue